var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoundationIconsVehiclesVanVanMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "m91zzsgdda",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#m91zzsgdda)",
    transform: "translate(-438.000000, -642.000000) translate(210.000000, 112.000000) translate(40.000000, 126.000000) translate(0.000000, 154.000000) translate(4.000000, 234.000000) translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.435,
    transform: "translate(24.000000, 16.000000) translate(1.000000, 7.500000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.261,
    cy: 10.588,
    rx: 1.435,
    ry: 1.412,
    transform: "translate(16.260870, 10.588235) scale(-1, 1) translate(-16.260870, -10.588235)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.783,
    cy: 10.588,
    rx: 1.435,
    ry: 1.412,
    transform: "translate(4.782609, 10.588235) scale(-1, 1) translate(-4.782609, -10.588235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.217 10.588L14.826 10.588",
    transform: "translate(10.521739, 10.588235) scale(-1, 1) translate(-10.521739, -10.588235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0H10.564c-.927 0-1.796.44-2.335 1.182L5.5 4.942H3.626c-1.403 0-2.6.997-2.83 2.359L.478 9.176c0 .78.643 1.412 1.435 1.412h2.87",
    transform: "translate(11.239130, 5.294118) scale(-1, 1) translate(-11.239130, -5.294118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.478 10.588L3.348 10.588 3.348 4.941",
    transform: "translate(1.913043, 7.764706) scale(-1, 1) translate(-1.913043, -7.764706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.478 4.941L16.978 4.941",
    transform: "translate(8.728261, 4.941176) scale(-1, 1) translate(-8.728261, -4.941176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.522 0L10.522 10.588",
    transform: "translate(10.521739, 5.294118) scale(-1, 1) translate(-10.521739, -5.294118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.941L5.5 0",
    transform: "translate(5.500000, 2.470588) scale(-1, 1) translate(-5.500000, -2.470588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.478 4.941L0.478 0",
    transform: "translate(0.478261, 2.470588) scale(-1, 1) translate(-0.478261, -2.470588)"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationIconsVehiclesVanVanMd);
export default __webpack_public_path__ + "static/media/foundation-icons-vehicles-van-van-md.0db1d9c1.svg";
export { ForwardRef as ReactComponent };